import { NearbyButtonType } from "@habity/types";

export const NEARBY: NearbyButtonType[] = [
  {
    title: "Bageri",
    key: "bakery",
  },
  {
    title: "Café",
    key: "cafe",
  },
  {
    title: "Deli",
    key: "deli",
  },
  // {
  //   title: 'Flygplats',
  //   key: 'airport',
  // },
  {
    title: "Mataffär",
    key: "supermarket",
  },
  {
    title: "Park",
    key: "park",
  },
  {
    title: "Förskola",
    key: "kindergarten",
  },
  {
    title: "Skola",
    key: "school",
  },
  {
    title: "Högskola",
    key: "college",
  },
  {
    title: "Universitet",
    key: "university",
  },
  {
    title: "Bibliotek",
    key: "library",
  },
  {
    title: "Gym",
    key: "fitness_centre",
  },
  {
    title: "Utegym",
    key: "fitness_station",
  },
  {
    title: "Frisör",
    key: "hairdresser",
  },
  {
    title: "Kemtvätt",
    key: "dry_cleaning",
  },
  {
    title: "Marina",
    key: "marina",
  },
  {
    title: "Lekplats",
    key: "playground",
  },
  {
    title: "Kiosk",
    key: "kiosk",
  },
  {
    title: "Tandläkare",
    key: "dentist",
  },
  {
    title: "Massage",
    key: "massage",
  },
  {
    title: "Salong",
    key: "beauty",
  },
  {
    title: "Snabbmat",
    key: "fast_food",
  },
  {
    title: "Idrottsplats",
    key: "pitch",
  },
  {
    title: "Sporthall",
    key: "sports_centre",
  },
  {
    title: "Golfklubb",
    key: "golf_course",
  },
  {
    title: "Båtklubb",
    key: "slipway",
  },
  {
    title: 'Arena',
    key: 'stadium',
  },
  {
    title: "Busstation",
    key: "bus_station",
  },
  {
    title: 'Tågstation',
    key: 'railway_station',
  },
  {
    title: "Färjeterminal",
    key: "ferry_terminal",
  },
  {
    title: "Restaurang",
    key: "restaurant",
  },
  {
    title: "Närbutik",
    key: "convenience",
  },
  {
    title: "Pub",
    key: "pub",
  },
  // {
  //   title: 'Biograf',
  //   key: 'cinema',
  // },
  // {
  //   title: 'Sjukhus',
  //   key: 'hospital',
  // },
  {
    title: "Vårdcentral",
    key: "clinic"
  },
  {
    title: "Apotek",
    key: "pharmacy",
  },
  {
    title: "Lanthandel",
    key: "agrarian",
  },
  // {
  //   title: "Kyrka",
  //   key: "place_of_worship",
  // },
  {
    title: "Badplats",
    key: "public_bath",
  },
];
